import AddUser from "../../svg/add-user";

const AssignTo = () => {
  return (
    <div className="assigned-to-container flex items-center gap-1">
      <AddUser />
      <div className="assigned-to-text truncate text-small font-normal leading-snug text-tertiaryBlue-4">
        Assign to
      </div>
    </div>
  );
};

export default AssignTo;
